import type { TableDensity } from "@/ds";
import type { ObrasColumnKey } from "../../types-obras-lista";

/**
 * Larguras do Figma, em rem, por densidade: Confortável em 5651:228915 / 11161:217296 e Compacto em 11457:127680
 * (as colunas de rótulo abreviado são mais largas). A tabela usa layout fixo: a coluna tem exatamente esta largura,
 * e um código maior que ela termina em reticências (`.idCell`).
 * A lupa não está aqui: ver `ACTION_COLUMN_WIDTH`.
 */
export const COLUMN_WIDTHS: Record<TableDensity, Partial<Record<ObrasColumnKey, string>>> = {
  normal: {
    id: "7.75rem", // 124, sem token (Figma 59): OBR-TST-0003 tem 90 + 14 de padding de cada lado = 118, folga de 6
    embarcacao: "9.6875rem", // 155
    statusObra: "7.5rem", // 120
    tipoObra: "9.6875rem", // 155
    condicao: "6.5rem", // 104
    inicio: "6.0625rem", // 97
    termino: "6.0625rem", // 97
    duracao: "5.3125rem", // 85
    realizado: "6.375rem", // 102
    totalServicos: "6.375rem", // 102
    percServicos: "6.8125rem", // 109
    totalMateriais: "5.125rem", // 82
    percMateriais: "7.0625rem", // 113
    totalFacilidades: "7.0625rem", // 113
    percFacilidades: "7.5rem", // 120
  },
  small: {
    id: "6.75rem", // 108, sem token (Figma 44): OBR-TST-0003 tem 90 + 7 de padding de cada lado = 104, folga de 4
    embarcacao: "9.6875rem", // 155
    // sem token no Figma: o frame tem 120 sem o ícone de ordenação; com ele (14 + 8) "Status da Obra" pede ~134 numa linha
    statusObra: "8.375rem", // 134
    tipoObra: "7.8125rem", // 125
    condicao: "6.5rem", // 104
    inicio: "6.0625rem", // 97
    termino: "6.0625rem", // 97
    duracao: "5.3125rem", // 85
    realizado: "6.375rem", // 102
    totalServicos: "7.0625rem", // 113
    percServicos: "7.8125rem", // 125
    totalMateriais: "5.125rem", // 82
    percMateriais: "7.75rem", // 124
    totalFacilidades: "7.75rem", // 124
    percFacilidades: "8.8125rem", // 141
  },
};

/** Coluna da lupa: 28 de botão + 12 de cada lado no Confortável (11161:217296) e 7 no Compacto (11457:127680). */
export const ACTION_COLUMN_WIDTH: Record<TableDensity, string> = {
  normal: "3.25rem",
  small: "2.625rem",
};

/** Coluna "Obra" do mobile (11466:10840): 155px de célula; o separador de 1px fica na borda da própria célula. */
export const MOBILE_OBRA_WIDTH = "9.6875rem";

/** Colunas não fixas que absorvem a sobra de largura em janelas largas, por ordem de preferência (texto livre primeiro). */
export const GROW_COLUMNS: ObrasColumnKey[] = ["condicao", "statusObra", "tipoObra"];

/** Colunas de tags: recuo próprio na célula. */
export const TAGS_COLUMNS: ObrasColumnKey[] = ["tipoObra"];
